import React, { useState, useEffect } from "react";
import '../../App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import navIcon1 from '../../assets/img/nav-icon1.svg';
import navIcon2 from '../../assets/img/nav-icon2.svg';
import navIcon3 from '../../assets/img/nav-icon3.svg';
import { Footer } from "../Footer";

export const LanguageTranslator = () => {
    // const [activeLink, setActiveLink]=useState('home');
    const [scolled, seScrolled] = useState(false);
    
    useEffect(()=>{
        const onScroll = () => {
            if (window.scrollY > 50){
                seScrolled(true);
            }else{
                seScrolled(false);
            }
        }

        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll)
    }, [])

    // const onUpdateActiveLink = (value) => {
    //     setActiveLink(value);
    // }
    return(
        <div>
            <Navbar expand="lg" className={scolled ? "scrolled": ""}>
                <Container>
                    
                    <Navbar.Brand href="/">
                        <div class="logo">
                        meet jo<b>.</b>
                        </div>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav">
                        <span className = "navbar-toggler-icon"></span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {/* <Nav.Link href="/" className = {activeLink === 'home' ? 'active navbar-link': 'navbar-link'} onClick={()=>onUpdateActiveLink('home')}>Go back to homepage</Nav.Link> */}
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            <a href = "https://github.com/joeygitari" target='blank' rel='noreferrer'><img src={navIcon1} alt =""/></a>
                            <a href = "https://www.linkedin.com/in/joanne-gitari-48105b235/" target='blank' rel='noreferrer'><img src={navIcon2} alt =""/></a>
                            <a href = "https://twitter.com/jo_gitari" target='blank' rel='noreferrer'><img src={navIcon3} alt =""/></a>
                        </div>
                    </span>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container className="tourism-header">
                <h1>AI Language Translator</h1>
                <h7>Translate with ease using AI tools</h7>
                <div className="tourism-content">
                    <h3>Project Summary</h3>
                    <div className="row">
                    <div className="col-md-6">
                            <ul className="summary-list">
                                <li>
                                    <b>Purpose:</b> School project
                                </li>
                                <li>
                                    <b>Core tasks:</b> Artificial Intelligence Application
                                </li>
                                <li>
                                    <b>Development:</b> Python
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <ul className="summary-list">
                                <li>
                                    <b>Start Date:</b> October 2022
                                </li>
                                <li>
                                    <b>End Date:</b> January 2023
                                </li>
                                <li className="project_url">
                                    <b>Github repository link:</b> <a href="https://github.com/joeygitari/Google-Translator-App" target='_blank' rel='noreferrer'>Language Translator AI App</a>
                                </li>
                            </ul>
                            <br />
                            <br />
                        </div>
                        <div className="col-md-12">
                        An advanced application designed to accurately identify and translate multiple languages in real time. 
                        Built using Python and leveraging natural language processing (NLP) libraries, the app can recognize written text and provide instant translations across various languages. 
                        By utilizing machine learning algorithms, it continuously improves its accuracy and efficiency, making communication easier and more accessible for users. 
                        This project showcases the transformative potential of AI in breaking down language barriers and facilitating seamless interactions in a globalized world.
                        {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ante diam, egestas placerat velit sed, ultricies ullamcorper nibh. Praesent mattis, velit ac pulvinar finibus, massa lacus luctus lectus, ut pulvinar magna enim in massa. Cras eu dictum urna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Morbi eget mauris dui. Mauris sed laoreet leo, et facilisis leo. Proin viverra, turpis eleifend lacinia pulvinar, ante nibh luctus velit, sit amet elementum augue lectus quis libero. Quisque pharetra scelerisque enim, eget imperdiet justo consectetur sit amet. Fusce et feugiat dui, eget bibendum ex. Fusce efficitur elementum scelerisque.  */}
                        {/* Quisque in nulla vitae orci posuere porttitor commodo non est. Duis non tellus iaculis, elementum elit ac, tincidunt arcu. Aenean eu urna vitae enim venenatis posuere. Quisque at lectus nec sem egestas rutrum. Nunc eros nulla, ullamcorper eu volutpat eu, convallis eu nisi. In leo nisl, sodales at imperdiet vel, egestas ut eros. Fusce sit amet augue ac ligula sagittis tincidunt ac ornare neque. Cras ut velit at lorem cursus blandit quis nec elit. Interdum et malesuada fames ac ante ipsum primis in faucibus. Nulla nec fringilla dui. Pellentesque ultricies venenatis quam euismod porttitor. */}
                        </div>
                    </div>
                </div>
            </Container>
            <Footer />
        </div>

    );
}